import React from "react";
import "./Custom.css";
import PropTypes from "prop-types";

const SectionHeading = ({ heading }) => {
  const { subHeading, headingOne, headingTwo, describe } = heading;
  SectionHeading.propTypes = {
    heading: PropTypes.object.isRequired, // Replace `object` with the correct type
  };
  return (
    <div className=" text-center">
      <h3 className="text-secondary text-2xl font-semibold">{subHeading}</h3>
      <h2 className="font-bold lg:text-5xl md:text-3xl text-2xl my-2 title text-center ml-0 !text-white !leading-[140%]">
        {headingOne} <span className="text-pent">{headingTwo}</span>
      </h2>
      <p className="pb-[3rem] paragraph !text-white">{describe}</p>
    </div>
  );
};

export default SectionHeading;
